import React, {  } from 'react'
import {AppFormItemProps} from './index'
import {AppFormSectionProps} from './AppFormSection'
import api, { AppFormSaveItem } from 'api'
import {appEnum} from 'utils/appEnum'
import {appDate,appNumber} from 'utils'
import {AppFormProps} from './AppForm'

interface AppFormServerProps extends AppFormProps{
	children?:React.ReactNode
}

export class AppFormServer  {
    
    private itemList:AppFormItemProps[];
    private sectionList :AppFormSectionProps[];

    constructor (props:AppFormServerProps){
		
        this.itemList = [];
		this.sectionList =[];
		let formData = props.formData || {};

        React.Children.toArray(props.children).forEach((section:any,index:number)=>{
			let sectionKey = index;
			let sectionHidden = section.props.hidden || false;
			let sectionProps = {...section.props,sectionKey,hidden:sectionHidden} as AppFormSectionProps
			this.sectionList.push(sectionProps);
            React.Children.toArray(section.props.children).forEach((item:any,itemIndex:number)=>{
				let itemInitProps = {...item.props} as AppFormItemProps;
				let itemHidden = itemInitProps.hidden || false;
				let keyName = itemInitProps.keyName || itemInitProps.field || '';
				let textKeyName = itemInitProps.textKeyName || itemInitProps.textField || '';
				let unSave = itemInitProps.unSave || false;
				let textSave = itemInitProps.textSave || false;
				let readonly = props.mode===3 ? true : (itemInitProps.readonly ||　false);
				let value = appFormUtils.getItemSaveValue(formData[keyName],itemInitProps);
				let text = formData[textKeyName] || '';
                let itemProps = {...itemInitProps,sectionKey,hidden:itemHidden,unSave,textSave,keyName,textKeyName,readonly,value,text} as AppFormItemProps;
                this.itemList.push(itemProps);
            })
        });
        
    }

    getItemList = () =>{
        return this.itemList;
    }

    getSectionList = () =>{
        return this.sectionList;
    }
    
}

export const appFormUtils = {
	getItemValue : (appFormItem: AppFormItemProps) =>{
		switch(appFormItem.dataType){
			case appEnum.dataType.boolean:
				return appFormItem.value === '1';
			case appEnum.dataType.date:
			case appEnum.dataType.datetime:
				return appDate.returnValue(appFormItem.value);
			case appEnum.dataType.number:
				let numberType = (appFormItem.format === appEnum.format.int)?'int':'float';
				return  appNumber.returnValue(appFormItem.value,numberType);
		}
		return appFormItem.value;
	},
	getItemSaveValue : (value?:any,appFormItem?: AppFormItemProps) =>{
		if(value !== null && value !== undefined && value === 0) value = '0'
		let stringValue = `${value||''}`;
		switch(appFormItem.dataType){
			case appEnum.dataType.boolean:
				return stringValue === 'true' ? '1' :'0';
			case appEnum.dataType.date:
			case appEnum.dataType.datetime:
				return appDate.format(stringValue,appFormItem.format);
		}
		return `${value||''}`;
	},

	getSaveDataItemList:(formData?:any,itemList?:AppFormItemProps[]) =>{
		let formItemList :AppFormSaveItem[] = [];

		itemList && itemList.map((item:AppFormItemProps)=>{
			if(item.field){
				if(!item.unSave){
					let scopeItem = getScopeFieldDataType(itemList,item.scopeField);
					let formItem = getSaveItem(item,formData,scopeItem);
					formItemList.push(formItem);
				}
			}
			
			if(item.textSave){
				let formTextItem = getSaveItemText(item,formData);
				formItemList.push(formTextItem);
			}
			
		})

		return formItemList;
	}

	
}


const  getScopeFieldDataType = (itemList?:AppFormItemProps[],scopeField?:string) =>{
	let dataType = appEnum.dataType.number;
	let keyName = '';
	itemList && itemList.map((item:AppFormItemProps)=>{
		if(item.field === scopeField){
			dataType = item.dataType ||appEnum.dataType.string; 
			keyName = item.keyName;
		}
	})
	return {dataType,keyName};
}

const getSaveItem = (item?:AppFormItemProps,formData?:any,scopeItem?:{dataType?:string,keyName?:string}) =>{
	let {dataType,field,label,unRepeat,scopeField,keyName} = item;
	let value = appFormUtils.getItemSaveValue(formData[keyName],item);
	dataType = dataType || 'string'
	label = label || ''
	unRepeat = unRepeat || false
	scopeField = scopeField || ''
	let scopeDataType = scopeItem.dataType;
	let scopeValue = scopeItem.keyName === '' ? '': `${formData[scopeItem.keyName] || ''}`
	let formItem:AppFormSaveItem = {dataType,field,label,unRepeat,scopeField,keyName,value,scopeDataType,scopeValue};
	return formItem;
}

const getSaveItemText = (item?:AppFormItemProps,formData?:any) =>{
	let {textField,textKeyName,label} = item;
	let field = textField;
	let value = formData[textKeyName]||'';
	let dataType = 'string';
	label =item.label || ''
	let unRepeat = false
	let scopeField = ''
	let scopeDataType = '';
	let scopeValue = '';
	let formItem:AppFormSaveItem = {dataType,field,label,unRepeat,scopeField,keyName:textKeyName,value,scopeDataType,scopeValue};
	return formItem;
}


// WEBPACK FOOTER //
// ./src/qcc/AppForm/AppFormServer.tsx